import { Outlet } from 'react-router-dom'
import { ROUTES } from '@/app/app/routing/routes'
import { CompanyStatsPage } from '@/app/entities/companyStats'
import { CompanyStatsViewTabs } from '@/common/entities/companyStats'

export const StatsLayout = () => {
    return (
        <div className='flex min-w-0 flex-col gap-6'>
            <CompanyStatsViewTabs basePath={ROUTES.STATS} />
            <Outlet />
        </div>
    )
}

export const StatsSummaryPage = () => <CompanyStatsPage view='stats' />

export const StatsComparePage = () => <CompanyStatsPage view='compare' />

export const StatsDetailedPage = () => <CompanyStatsPage view='detailed' />
